import {NgModule} from '@angular/core';
import {LoginComponent} from './components/login/login.component';
import {AuthenticationRoutingModule} from './authentication-routing.module';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {LogoutComponent} from './components/logout/logout.component';
import {AppToastrModule} from '@shared/libraries/ngx-toastr/toastr.module';
import {InputModule} from '@shared/modules/form/modules/input/input.module';
import {ButtonsModule} from '@shared/modules/buttons/buttons.module';

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent
  ],
  exports: [
    LogoutComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthenticationRoutingModule,
    InputModule,
    AppToastrModule,
    ButtonsModule,
  ]
})
export class AuthenticationModule { }
